var portfolioEdit = {
	confirmBtn: "Ok",
	cancelBtn: "Annulla",
	title: "Modifica portafoglio virtuale",
	nameInputLabel: "Nome del Portafoglio",
	nameInputPlaceholder: "Inserire un nome",
	nameInputTip: "Max. 100 caratteri - Caratteri validi a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	currencyInputLabel: "Valuta di Base del Portafoglio",
	currencyInputPlaceholder: "Seleziona una valuta",
	limitExceededMessage: "Superatio il limite di portafoglio.",
	currencies: {
		euro: "Euro",
		usd: "Dollari Americani",
		chf: "Franchi Svizzeri",
		gbp: "Sterlina Britannica",
		jpy: "Yen Giapponese",
		cad: "Dollaro Canadese"
	},
	validationErrors: {
		name: {
			invalidInput: "Il nome non è valido. Max. 100 caratteri – Caratteri validi a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var it = {
	portfolioEdit: portfolioEdit
};

export { it as default, portfolioEdit };
